exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_wks-ext.js
// module id = ./node_modules/core-js/library/modules/_wks-ext.js
// module chunks = 168707334958949